module.exports = __webpack_public_path__ + "img/icon_heart.c2266b7f.svg";